var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1155_29703",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H20V20H0V0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1155_29703)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5001 3.33335C16.5751 3.04169 15.5584 2.91669 14.5834 2.91669C12.9584 2.91669 11.2084 3.25002 10.0001 4.16669C8.79177 3.25002 7.04177 2.91669 5.41677 2.91669C3.79177 2.91669 2.04177 3.25002 0.833435 4.16669V16.375C0.833435 16.5834 1.04177 16.7917 1.2501 16.7917C1.33344 16.7917 1.3751 16.75 1.45844 16.75C2.58344 16.2084 4.20844 15.8334 5.41677 15.8334C7.04177 15.8334 8.79177 16.1667 10.0001 17.0834C11.1251 16.375 13.1668 15.8334 14.5834 15.8334C15.9584 15.8334 17.3751 16.0834 18.5418 16.7084C18.6251 16.75 18.6668 16.75 18.7501 16.75C18.9584 16.75 19.1668 16.5417 19.1668 16.3334V4.16669C18.6668 3.79169 18.1251 3.54169 17.5001 3.33335ZM17.5002 14.5834C16.5835 14.2917 15.5835 14.1667 14.5835 14.1667C13.1668 14.1667 11.1252 14.7084 10.0002 15.4167V5.83335C11.1252 5.12502 13.1668 4.58335 14.5835 4.58335C15.5835 4.58335 16.5835 4.70835 17.5002 5.00002V14.5834Z",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.e83a5abf44ea37bba5d3f521a872ecd4.svg";
export { ForwardRef as ReactComponent };